export class HallResearchEmcee {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.0.0';
        this.power = true;
        this.presetSelection = '1';
        this.recordState = false;
        this.volume = '50';
        this.asyncHandlers = [
            {
                name: 'firmwareQuery',
                regExp: /FW\??/i,
                callback: (match) => {
                    this.socket.send(`VER ${this.firmwareVersion}`);
                },
            },
            {
                name: 'power',
                regExp: /PW([\?01])/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.power = match[1] === '1';
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`PW${this.power ? '1' : '0'}`);
                    }
                },
            },
            {
                name: 'preset',
                regExp: /PR(\?|\d+)/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.presetSelection = match[1];
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`PR${this.presetSelection}`);
                    }
                },
            },
            {
                name: 'record',
                regExp: /RC([\?01])/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.recordState = match[1] === '1';
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`RC${this.recordState ? '1' : '0'}`);
                    }
                },
            },
            {
                name: 'volume',
                regExp: /VOL(\?|\d+)/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.volume = match[1];
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`VOL${this.volume}`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`INVALID_COMMAND`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.presetSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.presetSelection = lowestCode ? lowestCode : '1';
    }
}
HallResearchEmcee.emulatorType = 'socketEmulator';
HallResearchEmcee.key = '-NMePR4ukVXDKvhH3wh5';
